import { render, staticRenderFns } from "./Ultima.vue?vue&type=template&id=6d680649&scoped=true&"
import script from "./Ultima.vue?vue&type=script&lang=js&"
export * from "./Ultima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d680649",
  null
  
)

export default component.exports